import React from "react";
import Layout from "../../layouts/Layout";
import IconIphone from "../../components/icons/icon-iphone";
import IconRenew from "../../components/icons/icon-renew";
import BButton from "../../components/general/BButton";
import TextFieldSC from "../../components/TextFieldSC";
import SelectSC from '../../components/SelectSC'
import MenuItem from '@mui/material/MenuItem';
import PackageSelect from './PackageSelect'

import moment from "moment";
import { Label } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import apiService from '../../utils/api.service';
import helper from "../../utils/helper";
import SpaceBar from "../../components/general/SpaceBar";
class RenewMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      isSubmit: false,
      error: {},
      data: {
        firstname: "",
        lastname: "",
        bank: "",
        amount: "",
      },
      loading: false,
      memberNumber: "001234569",
      selectPackage: 1,
      fileUpload: null,
      filename: '',
      refreshFile: false,
      imageErr: false,
      packageList: [
        { id: 1, price: 200, perUnit: 'บาท / เดือน' },
        { id: 2, price: 599, perUnit: 'บาท / ปี' },
      ]
    };
    this.uploadFile = this.uploadFile.bind(this)
    this.uploadClear = this.uploadClear.bind(this)
    this.onRenewSave = this.onRenewSave.bind(this)
    this.getBase64 = this.getBase64.bind(this)
  }
  changeValue(e, type, targetValue = "target") {
    console.log(e);
    let value = null;
    if ((targetValue = "target")) {
      value = e.target.value;
    } else {
      value = e;
    }
    console.log('value >>', value)
    let { data } = this.state;
    const nextState = data;
    nextState[type] = value;

    this.checkValidation(nextState);
    this.setState({ data: nextState });
  }
  checkValidation(data){
    // console.log("this.state.isSubmit",this.state.isSubmit);
    if(!this.state.isSubmit){
      return false;
    }
    let  error  =  this.state.error;
    let required = [
      'firstname',
      'lastname',
      'bank',
      'amount',
    ];
    let hasError = false;
    for (var i in data) {
      if(!data[i] && required.indexOf(i)>-1){
        error[i] = true;
        hasError = true;
      }else {
        error[i] = false
      }
    }
    this.setState({error:error});
    return hasError
  }
  uploadClear () {
    this.setState({ fileUpload: null, filename: '', refreshFile: true })
		setTimeout( () => this.setState({ refreshFile: false }), 50)
  }
  uploadImage (notImage = false) {
    if (notImage) {
      document.getElementById("uploadImage").click()
    }
  }
  uploadFile(e){
    console.log(e.target.files[0]);
    let file = e.target.files[0]
    console.log('file >>', file)
    const MAXSIZEFILE = helper.CONFIG.MAXSIZEFILE
    const IMGTYPEFILE = helper.CONFIG.IMGTYPEFILE
    console.log("MAXSIZEFILE", MAXSIZEFILE);
    if (IMGTYPEFILE.includes(file.type) && file.size <= MAXSIZEFILE) {
      this.getBase64(file)
    } else {
      this.setState({ imageErr: true });
    }
  }
  getBase64(file) {
     var reader = new FileReader();
     reader.readAsDataURL(file);
     reader.onload =  () => {
       const fileUpload = reader.result
       this.setState({ imageErr: false, fileUpload: fileUpload, filename: file.name})
     };
     reader.onerror = (error) => {
       console.log('Error: ', error);
     };
  }
  onRenewSave() {
    const { data, selectPackage } = this.state
    const { fileUpload, filename } = this.state
    const memberId =  this.props?.user?.lineId?.memberId
    const payload = {
        memberId: memberId,
        package: selectPackage,
        firstName: data.firstname,
        lastName: data.lastname,
        bank: data.bank,
        amount: Number(data.amount),
        picture: fileUpload,
    }
    
    console.log('payload >>', payload)
    let hasError = this.checkValidation(this.state.data)
    if(!hasError && fileUpload){
      this.CreateMemberPayment(payload)
      // this.props.navigate(`/renew-member-success`);
    }
  }
  async CreateMemberPayment(payload = {}) {
    try {
      this.setState({ loading: true });
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.Profile.CreateMemberPayment(payload, header)
      this.setState({ loading: false });
      if (resData.resultCode === "20000") {
        this.props.navigate(`/renew-member-success`);
      } else {
        Notification.error({ title: "ขออภัย", description: "รหัสผู้แนะนำไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง" });
      }
    }
    catch(e){
      this.setState({ loading: false });
      console.log('API ERR', e)
    }
  }
  render() {
    const { data, error, refreshFile, imageErr } = this.state;
    const { packageList, selectPackage } = this.state;
    const { isSubmit } = this.state;
    const { memberNumber, fileUpload } = this.state;
    const { option } = this.props;
    if (this.state.step > 0) {
      return (
        <Layout>
          <div className="container-renew2">
            <section className="renew-form">
              <h3>แจ้งชำระค่าสมาชิก</h3>
              {/* <h4>เลขที่สมาชิก : {memberNumber}</h4> */}
              <h4 style={{ marginBottom: '4px' }}>เลขที่สมาชิก : {this.props?.user?.lineId?.memberCode}</h4>
              <h4 style={{ color: '#d32f2f', fontSize: '12px', lineHeight: '140%' }}>*สามารถโอนเงินไปที่ ธนาคารไทยพาณิชย์ เลขที่บัญชี 380-447816-0 ชื่อบัญชี ห้างหุ้นส่วนจำกัด ทีม เนิส (ไทยแลนด์)</h4>
              <p>กรุณาเลือกแพ็คเกจ</p>
              <PackageSelect packageList={packageList} value={selectPackage} onSelect={(e) => this.setState({ selectPackage: e })}/>
              <form>
                <div className="box-form">
                  <div className="input-form">
                    <TextFieldSC
                      label="ชื่อ"
                      id="firstname"
                      variant="standard"
                      fullWidth
                      required={true}
                      error={error.firstname}
                      onChange={(e) => this.changeValue(e, "firstname")}
                    />
                  </div>
                  <div className="input-form">
                    <TextFieldSC
                      label="นามสกุล"
                      id="lastname"
                      variant="standard"
                      required={true}
                      fullWidth
                      error={error.lastname}
                      onChange={(e) => this.changeValue(e, "lastname")}
                    />
                  </div>
                  <div className="input-form">
                    <SelectSC
                      error={error.bank}
                      onChange={e => this.changeValue(e, 'bank')}
                      labelId="bank"
                      required={true}
                      id="bank"
                      label="ธนาคาร"
                      variant="standard" fullWidth
                      displayEmpty
                      value={data.bank}
                    >
                      <MenuItem disabled value="">ธนาคาร<span className="txt-err">*</span></MenuItem>
                      {
                        option.bank.map((item,index) => (
                          <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                        ))
                      }
                    </SelectSC>
                  </div>
                  <div className="input-form">
                    <TextFieldSC
                      label="จำนวนเงิน"
                      id="amount"
                      variant="standard"
                      required={true}
                      fullWidth
                      error={error.amount}
                      onChange={(e) => this.changeValue(e, "amount")}
                    />
                  </div>
                  <div className="input-form">
                    <div className="upload-slip">
                      <label>รูปภาพหลักฐานการโอนเงิน <span className="txt-err">*</span></label>
                      { refreshFile  === false? 
                        <input id="uploadImage" accept="image/*" type="file" onChange={this.uploadFile}/>
                        : <></>
                      }
                      <div className="upload-container">
                        { fileUpload === null ?
                        <>
                          <div 
                            className={`input-upload ${ imageErr || isSubmit && !!fileUpload === false? 'err' : ''}`}
                            onClick={this.uploadImage}
                          >
                              <div className="icon">
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M40.8571 17.2857H26.7143V3.14286C26.7143 1.40741 25.3069 0 23.5714 0H20.4286C18.6931 0 17.2857 1.40741 17.2857 3.14286V17.2857H3.14286C1.40741 17.2857 0 18.6931 0 20.4286V23.5714C0 25.3069 1.40741 26.7143 3.14286 26.7143H17.2857V40.8571C17.2857 42.5926 18.6931 44 20.4286 44H23.5714C25.3069 44 26.7143 42.5926 26.7143 40.8571V26.7143H40.8571C42.5926 26.7143 44 25.3069 44 23.5714V20.4286C44 18.6931 42.5926 17.2857 40.8571 17.2857Z" fill="#DADADA"/>
                                </svg>
                              </div>
                              <h5>อัปโหลดรูปภาพ</h5>
                          </div>
                          { 
                            imageErr &&
                            <div className="err-img">
                              <div>สามารถอัพโหลดไฟล์ .jpg .jpeg .png เท่านั้น</div>
                              <div>ขนาดไฟล์ไม่เกิน 1 MB</div>
                            </div>
                          }
                        </> :
                        <>
                          <div className="input-upload active">
                            <div className="icon-clear" onClick={this.uploadClear}>
                              <svg width="20" height="20" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.10178 5.99792L3.05089 8.04881L2.1601 7.15802L4.21099 5.10713L2.14629 3.04244L3.03708 2.15165L5.08797 4.20253L7.15267 2.13784L8.04345 3.02862L5.97876 5.09332L8.04345 7.15802L7.15267 8.04881L5.10178 5.99792Z" fill="#C4C4C4"/>
                              </svg>
                            </div>
                            <img src={fileUpload} alt="file-upload"/>
                          </div>
                          { 
                            imageErr &&
                            <div className="err-img">
                              <div>สามารถอัพโหลดไฟล์ .jpg .jpeg .png เท่านั้น</div>
                              <div>ขนาดไฟล์ไม่เกิน 1 MB</div>
                            </div>
                          }
                        </>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <section className="footer-action">
                <BButton disable={this.state.loading} onClick={() =>{
                  this.setState({ isSubmit:true },() => {this.onRenewSave()})
                 }} setStyle="mini">ส่งข้อมูล</BButton>
              </section>
            </section>
          </div>
        </Layout>
      );
    }
    return (
      <Layout>
        <div className="container-renew">
          <div className="re-new-iphone">
            <IconRenew style={{ margin: "auto", textAlign: "center" }} />
            <IconIphone style={{ margin: "auto", textAlign: "center" }} />
          </div>
          <div className="renew-detail">
            <div className="renew-term">
              <ul className="des-renew-member">
                <li>การสมัครเป็นสมาชิก  การทำงานที่ตรงต่อเวลา ไม่ขาดลามาสาย การเก็บแต้มบุญ</li>
                <li>การสมัครสมาชิก</li>
                <li><SpaceBar/>1.	การสมัครสมาชิก รายเดือน 200 บาท</li>
                <li><SpaceBar/>2.	รายปี 599 บาท</li>
                <li>ค่าใช้จ่ายที่เกิดขึ้น  เป็นผลประโยชน์ กับท่านทั้งสิ้น</li>
                <li><SpaceBar/>•	การโอนเงินตรงเวลาผ่าน บัญชีบริษัท ฯ อัตโนมัติ  </li>
                <li><SpaceBar/>•	การสร้างความมั่นใจ กับท่าน สมาชิกและผู้ว่าจ้าง</li>
                <li><SpaceBar/>•	สมาชิกรายปี สามารถ รับโบนัสประจำปี และสิทธิประโยชน์ อื่นๆมากมาย</li>
                <li><SpaceBar/>•	มีความมั่นคง มีงานพร้อมรองรับแน่นอน</li>
                <li><SpaceBar/>•	มีความชัดเจน ในรายรับที่จะเกิดขึ้น สามารถวางแผนงาน วางอนาคตได้ชัดเจนมากขึ้น</li>
              </ul>
            </div>
            <BButton onClick={() => this.setState({ step: 1 })} setStyle="outline block">แจ้งชำระค่าสมาชิก</BButton>
          </div>
        </div>
      </Layout>
    );
  }
}

function RenewMemberRoute(props) {
  let navigate = useNavigate();
  return <RenewMember navigate={navigate} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(RenewMemberRoute);